export default "__VITE_ASSET__22xZhr3q__"